import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import InfoItem from './InfoItem';

import scss from './DataBlock.module.scss';

function DataBlock() {
  const { t } = useTranslation('resonance');

  const isProjectLoading = useSelector((state) => state.resonance.isProjectLoading);
  const { numberOfRespondents, totalNodeConnections, numberOfVariables, numberOfResponseData, benchmark } = useSelector(
    (state) => state.resonance,
  );

  const overallData = [
    {
      label: t('numberOfRespondents'),
      value: numberOfRespondents,
    },
    {
      label: t('numberOfVariables'),
      value: numberOfVariables,
    },
    {
      label: t('numberOfResponseData'),
      value: numberOfResponseData,
    },
    {
      label: t('totalNodeConnections'),
      value: totalNodeConnections,
    },
    {
      label: t('benchmark'),
      value: benchmark,
    },
  ];

  return (
    <ul className={scss.wrapper}>
      {overallData.map(({ label, value }) => (
        <InfoItem key={label} label={label} value={value} isLoading={isProjectLoading} />
      ))}
    </ul>
  );
}

export default DataBlock;
